import React from 'react';
import { theme, style } from 'constants';
import { View, Scene, AppHeader, Avatar, TabNavigator } from 'core';
import { IcoMaterial, IcoInfo, IcoAnnouncements } from 'icons';
import { getTypingIndicatorText, getWatching } from 'selectors';
import GroupInfo from 'cont/right/GroupInfo';
import Task from 'cont/right/GroupTask';
import Material from 'cont/right/GroupMaterial';
import InactiveCont from './inactive';
import * as actions from 'actions';
import { lang } from 'lang';

import Chat from 'cont/middle/Chat';

const styles = style({
  left: {
    flex: 0.6,
    borderColor: theme.gray_color_lighten(0.2),
    borderRightWidth: 0.5,
    paddingRight: 1
  },
  tabs_holder: {
    height: 64,
    flexDirection: 'row',
    padding: 10,
    borderColor: theme.gray_color_lighten(0.2),
    borderBottomWidth: 0.5
  },
  tab: {
    flex: 1,
    flexDirection: 'column'
  },
  title: {
    marginTop: 5
  }
});

const indexes = { INFO: 0, TASKS: 1, MATERIAL: 2 };
const routes = ['selectGroupInfo', 'selectTasks', 'selectMaterial'];

const onTabChanged = (val, nnn) => routes[val] && actions[routes[val]] && actions[routes[val]]();

const GroupContent = ({ selected, selected_tab }) => {
  const tabs = [{ icon: IcoInfo, text: lang.INFO }, { icon: IcoAnnouncements, text: lang.TASKS }, { icon: IcoMaterial, text: lang.MATERIAL }];

  return selected.inactive ? (
    <InactiveCont selected={selected} />
  ) : (
    <Scene>
      <AppHeader back title={selected.title} title_icon={<Avatar data={selected} size={40} />} sub_title={getTypingIndicatorText(selected) || getWatching(selected)} />
      <Scene style={{ flexDirection: 'row' }}>
        <View style={styles.left}>
          <Chat />
        </View>
        <View style={{ flex: 0.4 }}>
          <TabNavigator
            tabs={tabs}
            initialValue={indexes[selected_tab]}
            value={indexes[selected_tab]}
            onChange={onTabChanged}
            isTop
            tab_bar_style={{ borderBottomColor: theme.gray_color_lighten(0.2) }}
            tab_style={{ backgroundColor: 'white', height: 70 }}
          >
            <GroupInfo />
            <Task />
            <Material />
          </TabNavigator>
        </View>
      </Scene>
    </Scene>
  );
};
export default GroupContent;



// WEBPACK FOOTER //
// ./src/components/middle/group_content.web.js